<template>
  <li class="list-group-item">
    <h5 class="mb-1 text-center" :class="{'sold-out-name': product.count === 0}">
      {{ product.name }}
      <span
        v-if="product.count === 0"
        class="badge badge-pill badge-danger"
      >Agotado</span>
    </h5>
    <div class="row">
      <div class="col-12">
        <p class="my-0 font-size-up">
          {{ product.unitPrice | currency('Bs.', 2, {
          thousandsSeparator: ".",
          decimalSeparator: ",",
          symbolOnLeft: true,
          spaceBetweenAmountAndSymbol: true
          })
          }}
        </p>
        <p class="m-0">Cantidad deseada: {{ product.originalCount }}</p>
        <p class="m-0" :class="{'text-danger': product.count === 0, 'font-weight-bold': true}">Cantidad ofrecida: {{ count }}</p>
        <strong class="my-2 font-size-up">
          {{ product.total | currency('Bs.', 2, {
          thousandsSeparator: ".",
          decimalSeparator: ",",
          symbolOnLeft: true,
          spaceBetweenAmountAndSymbol: true
          })
          }}
        </strong>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ["product", "status"],
  computed: {
    count() {
      return this.status == "P" ? "Pendiente" : this.product.count
    }
  }
};
</script>

<style scoped>
.font-size-up {
  font-size: 17px;
}

.sold-out-name {
  text-decoration: line-through;
}
</style>